import styled from 'styled-components'

export default styled.section`

.inner {
    display: flex;
    position: relative;
    flex-direction: row;
    padding-top: 7rem;
    padding-bottom: 7rem;
    background: ${props => props.ctaBackgroundColor || rgba(197, 233, 254, 1)};
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        flex-direction: column;
        align-items: center;
        padding-inline: 3rem;
        }

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
        padding-inline: 3rem;
        }

    .logo-buttons {

    }

    .btn-container{
        padding: 1rem 0;
        display: flex;
        gap: 20px;
    }

    .express-content {
        padding-left: 4rem;
        color: ${props => props.theme.colors.darkBlue};

        @media (max-width: ${props => props.theme.breakpoints.tablet}) {
            padding-left: 0rem;
            flex-direction: column;
            text-align: center;
            padding-inline: 3rem;
            }
    }
` 